import { Fragment, useEffect, useState } from "react";
import SwiperCore, { Pagination, Navigation, Autoplay, EffectFade } from "swiper";
import { useTranslation } from "react-i18next";
import Banner from "../../components/banner";
import { WhyHJSection } from "../../sections/whyHJSection";
import { TestimonialSection } from "../../sections/testimonialSection";
import Breadcrumb from "../../components/__simple/breadcrumb";
import axios from "axios";
import AwardsSection from "./components/about-awards";
import VisionsSection from "./components/about-visions";
import CounterSection from "./components/about-counter";
import { Helmet } from "react-helmet";
import config from '../../configuration/config';

SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade]);

export function AboutPage() {
    const { t: trans, i18n } = useTranslation(["common", "about"]);

    const [banner, setBanner] = useState({});
    const [awards, setAwards] = useState([]);
    const [visions, setVisions] = useState([]);
    const [about, setAbout] = useState({});

    let lang = (i18n.language || 'ar');
    const languageDir = 'language-' + lang;
    useEffect(() => {
        async function fetchInfo() {
            try {
                const response = await axios.request({
                    baseURL: config.controllURL,
                    url: lang + "/api/About/index",
                    method: "get",
                });
                setBanner(response.data.banner);
                setVisions(response.data.visions);
                setAwards(response.data.awards);
                setAbout(response.data.about);
            } catch (error) {
                console.log(error);
            }
        }
        fetchInfo();
    }, [lang]);

    const [seoPageInfo, setSeoPageInfo] = useState({});
    useEffect(() => {
        async function fetchSeo() {
            const pageName = "about us";
            try {
                const response = await axios.post(
                    `${config.controllURL}${lang}/api/Pages/SiteFetchSeoPages`,
                    {
                        "page": pageName
                    }
                );
                if (response.status === 200) {
                    setSeoPageInfo(response.data[0]);
                }
            } catch (e) {
                console.log(e);
            }
        }
        fetchSeo();
    }, []);

    return (
        <Fragment>

            {
                seoPageInfo &&

                <Helmet>

                    <meta charSet="utf-8" />
                    {
                        seoPageInfo?.title &&
                        <title>{seoPageInfo?.title}</title>
                    }
                    {
                        seoPageInfo?.link &&
                        <link rel="canonical" href={seoPageInfo?.link} />

                    }
                    {
                        seoPageInfo?.MetaDescription &&
                        <meta name="description" content={seoPageInfo?.MetaDescription} />
                    }
                    {
                        seoPageInfo?.MetaGroups &&
                        <meta name="keywords" content={seoPageInfo?.MetaGroups} />
                    }

                </Helmet>


            }
            <Banner
                subtitle={banner?.subtitle}
                title={banner?.title}
                desc={banner?.excerpt}
                background={banner?.imagePath}
                backOpasity={banner?.backOpasity}
            />

            <div className={`${languageDir} sec`}>
                <div className="container">
                    <Breadcrumb className={"mb-16"}
                        links={[
                            {
                                name: trans("common:about-us")
                            }
                        ]}
                    />
                </div>

                <WhyHJSection />

                <CounterSection about={about} />

                <div className="ctn sec">
                    <div className="stag">{trans("common:locations")}</div>
                    <h2 className="sh">{trans("about:about-box-title")}</h2>
                    <VisionsSection visions={visions} />
                </div>

                {about?.bannerPath && (
                    <div className={"ctn mb-36"}>
                        <img className={"rounded-2xl w-full object-cover shadow-2xl"} src={config.FilePathURL + about?.bannerPath} alt="hassan jameel" />
                    </div>
                )}

                <div className="ctn sec">
                    <div className="stag">{trans("about:sub-menue")}</div>
                    <h2 className="sh">{trans("about:Name-award")}</h2>
                    <AwardsSection awards={awards} />
                </div>

                <TestimonialSection />

                <div className="ctn sec" id='workPricipleElement'>
                    <div className="max-w-3xl mx-auto text-center">
                        <div className="stag justify-center">{trans("common:contact-us")}</div>
                        <h2 className="sh mb-8">{about?.lastTitle?.replace(/<br\s*\/?>/gi, ' ')}</h2>
                        <p className="text-18 text-t3 mb-10 leading-relaxed">
                            {about?.lastDesc?.replace(/<br\s*\/?>/gi, ' ')}
                        </p>
                        <a className={"bg-g text-white px-10 py-4 rounded-xl font-bold hover:bg-gd transition-all shadow-lg shadow-g inline-block"} href="/contact">
                            {trans("common:contact-us")}
                        </a>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}